module.exports = __webpack_public_path__ + "img/money.7120f982.svg";